module.exports = __webpack_public_path__ + "img/help1-1-1.f42ef55f.png";